<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div v-if="loading" class="alert alert-info" role="status">Loading...</div>
    <div v-if="error" class="alert alert-danger" role="alert"><span class="oi oi-warning" aria-hidden="true"></span> {{ error }}</div>
    <div v-if="deleteError" class="alert alert-danger" role="alert"><span class="oi oi-warning" aria-hidden="true"></span> {{ deleteError }}</div>

    <div v-if="item" class="table-responsive">
      <table class="table table-striped table-hover">
        <tbody>
          <tr>
            <td>Name</td>
            <td>{{ item['name'] }}</td>
          </tr>
          <tr>
            <td>Description</td>
            <td>{{ item['description'] }}</td>
          </tr>
          <tr>
            <td>Template</td>
            <td><ul class="nav nav-tabs" id="translationsTab" role="tablist">
              <li v-for="(value, key, index) in languages" class="nav-item">
                <a class="nav-link" v-bind:class="{ active: index===0, show: index===0 }"
                   :id="'translation-tab-' + key" data-toggle="tab"
                   :href="'#translation-tab-content-' + key" role="tab" :aria-controls="index"
                   aria-selected="false">{{
                  value }}</a>
              </li>
            </ul>
              <div class="tab-content" id="translationsTabContent">
                <div v-for="(value, key) in item.translations" class="tab-pane fade"
                     v-bind:class="{ active: key==='de', show: key==='de' }" :id="'translation-tab-content-' + key"
                     role="tabpanel" :aria-labelledby="'translation-tab-' + key">
                  <template v-for="line in item.translations[key]['template'].split('\n')">{{line}}<br></template>
                </div>

              </div></td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer class="footer fixed-bottom bn-footer">
      <div style="float:right">
        <router-link v-if="item" :to="{ name: 'TextBlockList' }" class="btn btn-primary btn-sm">Back to list</router-link>
        <button @click="deleteItem(item)" class="btn btn-danger btn-sm">Delete</button>
      </div>
    </footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {API_LANGUAGES} from '../../config/languages';

  export default {
    computed: mapGetters({
      deleteError: 'textblock/del/error',
      error: 'textblock/show/error',
      loading: 'textblock/show/loading',
      item: 'textblock/show/item',
    }),
    methods: {
      deleteItem (item) {
        if (window.confirm('Are you sure you want to delete this item?'))
          this.$store.dispatch('textblock/del/delete', item).then(response => this.$router.push({ name: 'TextBlockList' }));
      }
    },
    created () {
      this.$store.dispatch('textblock/show/retrieve', decodeURIComponent(this.$route.params.id));
    },
    beforeDestroy() {
      this.$store.dispatch('textblock/show/reset');
    },
      data: function () {
          return {
              languages: API_LANGUAGES
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/textblock/Show.vue